<template>
  <div>
    <el-descriptions>
      <el-descriptions-item
        :label="$l('INDEX.table_label_customer_name') || '客户名称'"
      >
        {{ formData.custName }}
      </el-descriptions-item>
    </el-descriptions>
    <el-form size="mini" :rules="rules" ref="form" :model="formData">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.table_label_endcustomer_name') || '终端客户'"
          >
            <dict-select
              clearable
              v-model="formData.endCustCode"
              :selectedLabel.sync="formData.endCustName"
              filterable
              url="/master/common/dict/customerSelect"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('INDEX.form_bookingStaff') || '制单人'">
            <dict-select
              url="/master/common/dict/baseUserSelect"
              v-model="formData.bookingStaffCode"
              :selectedLabel.sync="formData.bookingStaffName"
              :placeholder="
                $l('INDEX.form_Please_bookingStaff') || '请选择制单人'
              "
              clearable
              filterable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_shipmentStartDate') ||
                '客户最早交期'
            "
            prop="shipmentDate"
          >
            <el-date-picker
              v-model="formData.shipmentDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_shipmentEndDate') ||
                '客户最晚交期'
            "
            prop="shipmentEndDate"
          >
            <el-date-picker
              v-model="formData.shipmentEndDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_label_please_select_cargoReadyDay') ||
                  '请选择货好时间'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
            "
          >
            <dict-select
              filterable
              v-model="formData.dispatchPort"
              url="/master/port/select"
              size="mini"
              clearable
              :placeholder="
                $l('INDEX.form_placeholder_dispatchPort') || '请选择发运港口'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
            "
          >
            <dict-select
              filterable
              v-model="formData.destinationPort"
              url="/master/port/select"
              size="mini"
              clearable
              :placeholder="
                $l('INDEX.placeholder_destinationPort') || '请选择目的港口'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <BatchTable
        ref="batchTable"
        class="mt-2"
        :tableData="data"
        :errorKeys="errorKeys"
        @delete="(e) => $emit('delete', e)"
      />
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import BatchTable from './table.vue'
export default {
  components: { BatchTable },
  props: {
    data: { type: Array, default: () => [] },
    errorKeys: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        custCode: '',
        custName: '',
        endCustCode: '',
        endCustName: '',
        shipmentDate: '',
        shipmentEndDate: '',
        deliveryDate: '',
        dispatchPort: '',
        destinationPort: '',
        bookingStaffCode: '',
        bookingStaffName: '',
      },
      rules: {
        shipmentDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        shipmentEndDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_cargoReadyDay') ||
              '请选择货好时间',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.bookingStaffCode = userCode || ''
        this.formData.bookingStaffName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.data || !this.data.length) return
      if (this.errorKeys && this.errorKeys.length) return

      const {
        custCode = '',
        custName = '',
        endCustCode = '',
        endCustName = '',
        shipmentDate = '',
        shipmentEndDate = '',
        deliveryDate = '',
        dispatchPort = '',
        destinationPort = '',
      } = this.data[0] || {}

      this.formData.custCode = custCode
      this.formData.custName = custName
      this.formData.shipmentDate = shipmentDate
      this.formData.shipmentEndDate = shipmentEndDate
      this.formData.deliveryDate = deliveryDate
      this.formData.dispatchPort = dispatchPort
      this.formData.destinationPort = destinationPort

      const result = this.data.every((item) => item.endCustCode === endCustCode)
      this.formData.endCustCode = result ? endCustCode : ''
      this.formData.endCustName = result ? endCustName : ''
    },
    async getData() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false
      return {
        ...this.formData,
        shipmentBatchCodeList: this.data.map((row) => row.shipmentBatchCode),
      }
    },
  },
}
</script>
